"use client";

import { Alert, AlertDescription, AlertTitle, Button } from "@oreme/ui";
import { TriangleAlert } from "lucide-react";
import React, { useEffect, type ReactElement } from "react";
import { useTranslations } from "next-intl";

function DevicesError({
  error,
  reset,
}: Readonly<{
  error: Error & { digest?: string };
  reset: () => void;
}>): ReactElement {
  const t = useTranslations("devices.Error");

  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className="relative flex justify-center items-center min-h-[calc(100svh-var(--globalnav-height))] overflow-hidden bg-background">
      <header className="relative z-10 flex flex-col gap-2 max-w-md items-center">
        <TriangleAlert strokeWidth={1} size={40} />
        <h1 className="text-2xl font-semibold p-1 animate__animated animate__slideInUp animate__faster">
          {t("title")}
        </h1>

        <div className="w-full flex flex-col gap-6  animate__animated animate__fadeIn animate__faster delay-0.5s p-1">
          <Alert variant="destructive">
            <AlertTitle>{error.name}</AlertTitle>
            <AlertDescription>{error.message}</AlertDescription>
          </Alert>
          <Button
            onClick={(): void => {
              reset();
            }}
          >
            {t("action")}
          </Button>
        </div>
      </header>
    </div>
  );
}

export default DevicesError;
